import { isUndefined } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectDepreciation, selectDepreciations } from './depreciationSelectors.ts';
import { selectCompSequence } from './orderSelectors.ts';
import { selectCostNew, selectCostNews } from './selectCostNew.ts';

const calculateImprovementsCost = (
  costNew: ReturnType<typeof selectCostNew>,
  depreciation: ReturnType<typeof selectDepreciation>,
) => {
  if (isUndefined(costNew) || isUndefined(depreciation)) {
    return undefined;
  }

  return costNew.add(depreciation);
};

export const selectImprovementsCost = createSelector(
  [selectCostNew, selectDepreciation],
  calculateImprovementsCost,
);

export const selectImprovementsCosts = createSelector(
  [selectCostNews, selectDepreciations, selectCompSequence],
  (costNews, depreciations, compSequence) => {
    const properties = ['subject', ...compSequence];

    return Object.fromEntries(
      properties.map((propID) => [
        propID,
        calculateImprovementsCost(costNews[propID], depreciations?.[propID]),
      ]),
    );
  },
);

export const selectImprovementsCostDisplay = createSelector(
  [selectImprovementsCost],
  (improvements) => {
    if (isUndefined(improvements)) {
      return undefined;
    }

    return improvements.toString(true);
  },
);

export const selectImprovementsCostsDisplay = createSelector(
  [selectImprovementsCosts],
  (improvementCosts) => {
    if (isUndefined(improvementCosts)) {
      return undefined;
    }

    return Object.fromEntries(
      Object.entries(improvementCosts).map(([propID, improvementCost]) => [
        propID,
        improvementCost?.toString(true),
      ]),
    );
  },
);
